var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('link',{attrs:{"rel":"stylesheet","href":"/css/theme.css"}}),_c('link',{attrs:{"rel":"stylesheet","href":"/css/custom.css"}}),_c('link',{attrs:{"rel":"stylesheet","href":"/css/phone.css"}}),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }